import { z } from 'zod';
import { STRING_ARRAY_FILTER_OPERATION, type StringArrayFilter } from './operation.js';

export const stringArrayValueSchema = z.array(z.string().nullable().optional()).nullable().optional();

export const stringArrayFilterSchema = z.union([
    z.object({
        operation: z.enum([STRING_ARRAY_FILTER_OPERATION.inArray.id]),
        array: z.string().array(),
        includeBlanks: z.boolean().optional(),
    }),
    z.object({
        operation: z.enum([
            STRING_ARRAY_FILTER_OPERATION.beginsWith.id,
            STRING_ARRAY_FILTER_OPERATION.endsWith.id,
            STRING_ARRAY_FILTER_OPERATION.containsLoose.id,
            STRING_ARRAY_FILTER_OPERATION.containsStrict.id,
            STRING_ARRAY_FILTER_OPERATION.doesNotContain.id,
        ]),
        value: z.string().nullable().optional(),
    }),
]);

export type StringArrayFilterSchema = z.infer<typeof stringArrayFilterSchema>;
export type StringArrayFilterSchemaWithoutInArray = Exclude<
    StringArrayFilterSchema,
    {
        operation: StringArrayFilter['inArray']['id'];
    }
>;
